import {envIsLocal} from '../../config';
import {useEntityTypeQueryResult} from '../../graphql/entityPage';
import {useProjectParams} from '../../pages/ProjectPage/useProjectParams';
import {ViewTypes} from '../../state/workspaces/types';
import {useAccountPrivileges} from '../../util/accounts/pricing';
import {useAccountSelectorContext} from '../Search/SearchNav/AccountSelectorContextProvider';
import {AccountType} from '../Search/SearchNav/types';

export const useIsUserSettingsWorkspaceTemplateDisplayed = () => {
  const {selectedAccount} = useAccountSelectorContext();

  if (envIsLocal) {
    return true;
  }

  // Intentionally don't check for isWorkspaceTemplateAccountPrivilegeEnabled because we want to show
  // the upgrade message if the org is not on the enterprise plan.
  return selectedAccount?.accountType !== AccountType.Personal;
};

export const useIsWorkspaceTemplateActionDisplayed = (
  currentWorkspaceType: ViewTypes
): {
  isLoadingEntityType: boolean;
  isWorkspaceTemplateActionDisplayed: boolean;
} => {
  const isRunView = currentWorkspaceType === 'run-view';
  // If viewer is on any personal entity page, either one they own or one they don't own,
  // we should not show the workspace template action. Personal entities do not belong to
  // an org, but the feature requires an entityOrgId so we remove thie completely.
  const {entityName} = useProjectParams();
  const {entityType, loading} = useEntityTypeQueryResult({
    entityName,
  });

  return {
    isLoadingEntityType: loading,
    // Intentionally don't check for isWorkspaceTemplateAccountPrivilegeEnabled because we want to show
    // the upgrade message if the org is not on the enterprise plan.
    isWorkspaceTemplateActionDisplayed:
      entityType !== 'personal' &&
      // Don't show on run views since workspace templates only apply to project views. We'll update this after unifying project and run views.
      !isRunView,
  };
};

export const useIsWorkspaceTemplatePrivilegeEnabled = () => {
  const {selectedAccount} = useAccountSelectorContext();
  // Note: this hook skips the account privileges query if envIsLocal already
  const {privileges} = useAccountPrivileges(selectedAccount);

  if (envIsLocal) {
    // There's no concept of account on server and all server accounts are on the enterprise plan for now.
    return true;
  }

  return privileges.workspaceTemplatesEnabled;
};
